import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Response_Processing from "../../../layout/Others/Response_Processing";
import { getItemToken } from "../../../Utils/localStorageUtils";
import { toast } from "react-toastify";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import NoRecordTable from "../../../components/CommonComponents/NoRecordTable";
import { CiShare1 } from "react-icons/ci";
import { FaEllipsisVertical } from "react-icons/fa6";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { findUploadName } from "../../../components/CommonMethod/CommonMethods";
import { connect } from "react-redux";
import { IconDeleteFigma, IconEditFigma } from "../../../Assets/MyIcons";
import { useMyContext } from "../../../components/Provider/CommonProvider";

function ManageArtistCategories({ siteTheme }) {
    const { deleteImageFile } = useMyContext()
    const BaseUrl = process.env.REACT_APP_Baseurl
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [apiData, setApiData] = useState();
    const [showOverlay, setShowOverlay] = useState(false);
    const [loading, setLoading] = useState(true)
    const [modalClose, setModalClose] = useState(false)
    const [selectAllData, setSelectAllData] = useState(false);
    const [itemDelete, setItemDelete] = useState([]);
    const [languageCode, setLanguageCode] = useState('');
    const headers = getItemToken('access_token')

    const languageApi = `${BaseUrl}/admin/User-Translate-Language`

    useEffect(() => {
        const fetchLanguageCode = async () => {
            try {
                const { data } = await axios.get(languageApi, { headers });
                if (data?.status) {
                    const language = data?.Language_Code || 'en';
                    setLanguageCode(language);
                } else {
                    console.warn('Unexpected API response format:', data);
                }
            } catch (error) {
                const errorMsg = error?.response?.data?.message || error.message || 'Unknown error';
                console.error('Error fetching language code:', errorMsg);
            }
        };
        fetchLanguageCode();
    }, []);

    const fetchData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/artist-category/index`, { headers: headers });
            setApiData(response?.data?.allArtistCategory);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            setLoading(false);
        }
    };

    const handleDeleteImage = async () => {
        await deleteImageFile(itemDelete, "ArtistCategory");
    }

    const handleDelete = async () => {
        setShowOverlay(true);
        handleCloseModal()
        await handleDeleteImage();
        try {
            const response = await axios.delete(`${process.env.REACT_APP_Baseurl}/admin/artist-category/multi-delete`, {
                headers: headers, data: { id: [...itemDelete] },
            });
            const result = response?.data;
            if (result?.status) {
                toast.success(result?.message)
                setWithOutRefresh(!withOutRefresh)
                setShowOverlay(false);
                setSelectAllData(false)
            }
            else {
                toast.error(result?.message)
                setShowOverlay(false);
            }
        }
        catch (err) {
            const errMessage = err?.response?.data?.message
            toast.error(errMessage)
            console.log(err)
        }
    }

    const handleDragEnd = (result) => {
        // Reordering logic if needed, currently just visual or same as video category
        if (!result.destination) return;
        const reorderedItems = Array.from(apiData);
        const [movedItem] = reorderedItems?.splice(result.source.index, 1);
        reorderedItems?.splice(result.destination.index, 0, movedItem);
        setApiData(reorderedItems);
        // saveShuffleOrder(reorderedItems); // Implement if ordering is supported in backend
    };

    const handleSelectAllData = () => {
        setSelectAllData(!selectAllData);
        setItemDelete(selectAllData ? [] : apiData?.map((item) => item?.id));
    };

    const handleSingleFile = (itemId) => {
        if (itemDelete?.includes(itemId)) {
            setItemDelete(
                itemDelete?.filter((id) => id !== itemId)
            );
        } else {
            setItemDelete([...itemDelete, itemId]);
        }
    };

    const handleSingleDelete = (id) => {
        setItemDelete([id]);
        setModalClose(true);
        setSelectAllData(false);
    };

    const handleCloseModal = () => {
        setModalClose(!modalClose)
        setItemDelete([]);
    }
    const handleOpenDeleteModal = async () => {
        setModalClose(!modalClose)
    }

    useEffect(() => {
        fetchData()
    }, [withOutRefresh])

    return (
        <div className="pb-5">
            {showOverlay && <Response_Processing></Response_Processing>}
            {modalClose && <AdminDeleteModal buttonSubmitId="artist-category-submit" modelClose={modalClose} deleteClose={handleCloseModal} deleteAction={handleDelete} buttonText={itemDelete?.length} />}
            <AdminNavbar heading="Artist Type" totalDataLength={apiData?.length} deleteCount={itemDelete?.length}
                deleteMethod={handleOpenDeleteModal} navigation="/add-artist-type" navText="Add Type" />
            <div className="bootstrapTable theme-bg-color p-3 rounded-2">
                <div className="">
                    <div className="row m-0 theme-border-bottom-secondary pb-3">
                        <div className="rowCheckboxDrag"> <label><input type="checkbox" id="artist-category-select-all" checked={selectAllData} onChange={handleSelectAllData} /> </label></div>
                        <div className="col-lg-9 col-md-9 col-sm-9 col-9 "> <label className="theme-text-color fw-bold fs-6"> Category </label> </div>
                        <div className="col-lg-2 col-md-2 col-sm-2 col-2">
                            <label className="theme-text-color fw-bold fs-6">Actions</label>
                        </div>
                        <div className="col-lg-1 col-md-1 col-sm-1 col-1"></div>
                    </div>
                </div>
            </div>

            <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="menu-items">
                    {(provided) => (
                        <ul
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            className="pb-5 px-0 theme-bg-color m-0 p-0 list-unstyled"
                        >

                            {loading ? (
                                <NoRecordTable result={apiData?.length} loader={true} />
                            ) : apiData?.length ? (

                                apiData.map((item, index) => (

                                    <Draggable
                                        key={item.id.toString()}
                                        draggableId={item.id.toString()}
                                        index={index}
                                        isDragDisabled={true} // disable drag for now as backend order support might strictly need position column
                                    >
                                        {(provided) => (

                                            <div ref={provided.innerRef} {...provided.draggableProps}>
                                                <li
                                                    id="artist-category-drag"
                                                    {...provided.dragHandleProps}
                                                    className="theme-bg-color theme-text-color w-100 theme-border-bottom-secondary px-3"
                                                >
                                                    <div className="row m-0 p-0 align-items-center">

                                                        <div className="rowCheckboxDrag category-order-title">
                                                            <input
                                                                type="checkbox"
                                                                checked={itemDelete.includes(item.id)}
                                                                onChange={() => handleSingleFile(item.id)}
                                                            />
                                                        </div>

                                                        <div className="col-lg-9 col-md-9 col-sm-9 col-9 category-order-title">
                                                            <div className="d-flex align-items-center gap-3">
                                                                <img src={item.image} className="profile" alt="" />

                                                                <div className="rightVideoTitle">
                                                                    <Link
                                                                        className="theme-text-color table-heading d-flex align-items-center"
                                                                        target="_blank"
                                                                        to={
                                                                            siteTheme?.translate_checkout === 1
                                                                                ? `${process.env.REACT_APP_Baseurl_Frontend}/${languageCode}/artistcategories/${item.slug}`
                                                                                : `${process.env.REACT_APP_Baseurl_Frontend}/artistcategories/${item.slug}`
                                                                        }
                                                                    >
                                                                        <span title={item.slug}>
                                                                            {item.name?.slice(0, 15)}...
                                                                        </span>
                                                                        {/* <CiShare1 style={{ width: 15, height: 15, marginLeft: 6 }} /> */}
                                                                    </Link>

                                                                    <span className="dateText table-subheading">
                                                                        {item.upload_on}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>



                                                        <div className="col-lg-2 col-md-2 col-sm-2 col-2 category-order-title">
                                                            <div className="editdropdown">
                                                                <span className="editdropdown-button">
                                                                    <FaEllipsisVertical className="theme-text-color" />
                                                                </span>
                                                                <div className="editdropdown-menu theme-bg-color">
                                                                    <Link to={`/edit-artist-type/${item.id}`} className="theme-text-color">
                                                                        <IconEditFigma styled={{ width: 20, height: 20 }} />
                                                                        <MessageBox text="Edit" classname="ms-2" />
                                                                    </Link>

                                                                    <div onClick={() => handleSingleDelete(item.id)} className="commonActionPadding">
                                                                        <IconDeleteFigma styled={{ width: 20, height: 20 }} />
                                                                        <MessageBox text="Delete" classname="ms-2" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-1 col-md-1 col-sm-1 col-1"></div>
                                                    </div>
                                                </li>
                                            </div>
                                        )}
                                    </Draggable>

                                ))

                            ) : (
                                <NoRecordTable result={apiData?.length} loader={false} />
                            )}

                            {provided.placeholder}
                        </ul>
                    )}
                </Droppable>
            </DragDropContext>

        </div>
    );
}
const mapStateToProps = (state) => ({
    siteTheme: state.siteTheme.siteTheme
});

export default connect(mapStateToProps)(ManageArtistCategories)
